// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedCarouselStyles } from "@vanmeter/App/SharedStyles/ProductCarouselStyles";
import { productCarouselStyles } from "@vanmeter/Overrides/Widgets/Common/ProductCarousel";
import { hideElementOnPrint } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productCarouselStyles.carouselProductMiniCardStyles = {
    ...sharedCarouselStyles.carouselProductMiniCardStyles,
};

productCarouselStyles.carouselProductCondensedStyles = {
    ...sharedCarouselStyles.carouselProductCondensedStyles,
};

productCarouselStyles.carouselSlidesContainer = {
    css: css`
        .slideContainer {
            width: 317px;
            min-width: 317px;
        }
    `,
};

productCarouselStyles.mainContainer = {
    css: css`
        ${({ isProductDetailsPage }: any) => isProductDetailsPage && `${hideElementOnPrint}`}
    `,
};

productCarouselStyles.titleText = {
    css: css`
        ${({ isProductDetailsPage }: any) => isProductDetailsPage && `${hideElementOnPrint}`}
    `,
};
